import { Text } from 'src/components/Text'
import type { TextProps } from 'src/components/Text'

export const FALLBACK_TEXT = '-'

type Props = {
  condition: boolean
  showFallback?: boolean
} & TextProps

export const ConditionalText = ({
  condition,
  children,
  showFallback = true,
  ...props
}: Props) => {
  return (
    <Text {...props}>
      {condition && children ? children : showFallback ? FALLBACK_TEXT : null}
    </Text>
  )
}
